<template>
	<el-row>
		<el-button @click='add'>新增一级类别</el-button>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" row-key="dicId"
			:tree-props="{children: 'sonDicList', hasChildren: 'hasChildren'}">
			<el-table-column prop="dicId" label="id" width="180">
			</el-table-column>
			<el-table-column prop="dicDesc" label="课件类别" width="180">
			</el-table-column>
			<el-table-column prop="dicInfo" label="类别介绍">
			</el-table-column>
			<el-table-column>
				<template slot-scope="scope">
					<el-button @click='add2(scope.row)' size="mini" v-if="scope.row.dicLevel == 1"
						style="color: #0099ff;">
						新增下级类别
					</el-button>
					<el-button type="text" style="color: #009900;" @click="bj(scope.row)">编辑</el-button>
					<el-button type="text" style="color: red;" @click="del(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>

		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center @close="gb()">
			<el-row>
				<el-form :model="info" :rules="infoRules" ref="info" label-position="right" label-width="90px">
					<el-form-item label="上级类别:" prop="sjlb" v-if="isShow">
						{{info.dicDesc2}}
					</el-form-item>
					<el-form-item label="课件类别:" prop="dicDesc">
						<el-input v-model="info.dicDesc" size="medium" placeholder="请输入(20个字)" maxlength="20"
							show-word-limit style="width: 400px">
						</el-input>
					</el-form-item>
					<el-form-item label="类别介绍:" prop="dicInfo" maxlength="20">
						<el-input type="textarea" rows="3" cols="20" v-model="info.dicInfo" size="medium"
							placeholder="请用精炼的语句(20个字)" maxlength="20" style="width: 400px" show-word-limit>
						</el-input>
					</el-form-item>
					<el-form-item label-width="180px">
						<el-button type="primary" @click="queren">确 定</el-button>
						<el-button @click="centerDialogVisible = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</el-row>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				isShow: false,
				centerDialogVisible: false,
				info: {
					dicDesc: '', //课件类别
					dicDesc2: '', //课件类别
					dicInfo: '', //类别结束
					parentId: '', //上级类别
					dicId: '', //id
				},
				infoRules: {
					dicDesc: [{
						required: true,
						trigger: 'blur',
						message: '请输入课件类别'
					}],
					dicInfo: [{
						required: true,
						trigger: 'blur',
						message: '请输入类别介绍'
					}]
				},
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 20,
				pagelist: [20, 50, 100],
			}
		},
		methods: {
			add() {
				this.title = "新增一级类别"
				this.centerDialogVisible = true
				this.info.dicDesc = ''
				this.info.dicInfo = ''
				this.isShow = false
			},
			add2(row) {
				console.log(row);
				this.info.dicDesc2 = row.dicDesc
				this.info.parentId = row.dicId
				this.title = "新增下级类别"
				this.centerDialogVisible = true
				this.info.dicDesc = ''
				this.info.dicInfo = ''
				this.isShow = true
			},
			bj(row) {
				console.log(row)
				this.info.dicDesc = row.dicDesc
				this.info.dicId = row.dicId
				if (row.dicLevel == 1) {
					this.title = "编辑一级类别"
					this.centerDialogVisible = true
					this.info.dicInfo = row.dicInfo
					this.isShow = false
				} else if (row.dicLevel == 2) {
					this.title = "编辑下级类别"
					this.centerDialogVisible = true
					this.info.dicDesc2 = row.dicDesc
					this.info.dicInfo = row.dicInfo
				}
			},
			gb() {
				this.centerDialogVisible = false
				this.getInfo()
			},
			queren() {
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.title == "新增一级类别") {
							this.$http.post("/api/setting/paiBoCategory/addPaiBoCategory", {
								"dicDesc": this.info.dicDesc,
								"dicLevel": 1,
								"parentId": this.info.parentId,
								"dicModular": 82,
								"dicInfo": this.info.dicInfo
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == "新增下级类别") {
							console.log(this.info.parentId);
							this.$http.post("/api/setting/paiBoCategory/addPaiBoCategory", {
								"dicDesc": this.info.dicDesc,
								"dicLevel": 2,
								"parentId": this.info.parentId,
								"dicModular": 82,
								"dicInfo": this.info.dicInfo
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
								} else {
									this.$message.error(res.data.msg)
								}
								this.centerDialogVisible = false
								this.getInfo()
							})
						} else if (this.title == "编辑一级类别") {
							this.$http.post(`/api/setting/paiBoCategory/updatePaiBoCategory`, {
								"dicDesc": this.info.dicDesc,
								"dicInfo": this.info.dicInfo,
								"dicId": this.info.dicId,
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == "编辑下级类别") {
							this.$http.post(`/api/setting/paiBoCategory/updatePaiBoCategory`, {
								"dicDesc": this.info.dicDesc,
								"dicInfo": this.info.dicInfo,
								"dicId": this.info.dicId,
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						}
					}
				})
			},
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/setting/paiBoCategory/deletePaiBoCategory?dicId=${row.dicId}`, {}).then(
						res => {
							if (res.data.data == 1) {
								this.$message.success(res.data.msg)
							} else {
								this.$message.error(res.data.msg)
							}
							this.getInfo()
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			getInfo() {
				this.$http.post(
					`/api/setting/paiBoCategory/selectPaiBoCategory?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
						"dicModular": 82
					}).then(res => {
					this.info.parentId = res.data.data.list[0].parentId
					this.total = res.data.data.total
					this.tableData = res.data.data.list
					console.log(this.tableData, this.info);
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">

</style>
